import { pushWithRegion } from 'actions/NavigationActions'
import LineShopIcon from 'LuxKit/Icons/line/LineShopIcon'
import { GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'
import { useGlobalMerchandiseSearchContext } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalMerchandiseSearch'
import useSearchVerticalLabels from 'hooks/GlobalSearch/useSearchVerticalLabels'
import { useAppDispatch } from 'hooks/reduxHooks'
import useQueryParams from 'hooks/useQueryParams'
import qs from 'qs'
import { useCallback, useMemo } from 'react'
import SearchV2MerchandiseTabContent from '../Components/Mobile/TabContents/SearchV2MerchandiseTabContent'

function useGlobalSearchVerticalTabMerchandise(): App.GlobalSearchVerticalTabV2 {
  const dispatch = useAppDispatch()
  const queryParams = useQueryParams()
  const verticalLabels = useSearchVerticalLabels()
  const [
    searchDispatch,
    state,
  ] = useGlobalMerchandiseSearchContext(GLOBAL_SEARCH_INITIAL_STATE, queryParams)

  const onSearch = useCallback(() => {
    const query = qs.stringify({
      search: state.searchItem?.value,
    })

    dispatch(pushWithRegion('/search/shop', query))
  }, [dispatch, state.searchItem?.value])

  return useMemo((): App.GlobalSearchVerticalTabV2 => ({
    label: verticalLabels.merchandise,
    key: 'merchandise',
    context: { dispatch: searchDispatch, state },
    onSearch,
    ContentComponent: SearchV2MerchandiseTabContent,
    Icon: LineShopIcon,
  }), [searchDispatch, state, onSearch, verticalLabels])
}

export default useGlobalSearchVerticalTabMerchandise
